import React from 'react'
import PropTypes from 'prop-types'
import Card from 'components/Card'
import MarkdownRenderer from 'components/MarkdownRenderer'
import { Spacing50 } from 'styles/sharedStyle'
import {
  Body,
  Eyebrow,
  Grid,
  Heading,
  Headline,
  Inner,
  Promo,
  Wrapper,
} from './PromoGrid.style'

const PromoGrid = ({ bodyCopy, eyebrow, headline, offers }) => {
  return (
    !!offers &&
    offers.length >= 3 && (
      <Wrapper>
        <Spacing50 />
        <Inner>
          {[bodyCopy, eyebrow, headline].some((s) => !!s) && (
            <Heading>
              {!!eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
              {!!headline && <Headline>{headline}</Headline>}
              {!!bodyCopy && <Body as={MarkdownRenderer} html={bodyCopy} />}
            </Heading>
          )}
          <Grid count={offers.length}>
            {offers.map(({ image, ...offer }, i) => (
              <Promo key={`offer${i.toString()}`}>
                <Card
                  {...{
                    image,
                    isSmall: true,
                    offer,
                  }}
                />
              </Promo>
            ))}
          </Grid>
        </Inner>
        <Spacing50 />
      </Wrapper>
    )
  )
}

PromoGrid.propTypes = {
  bodyCopy: PropTypes.shape({
    childMarkdownRemark: PropTypes.shape({
      html: PropTypes.string,
    }),
  }),
  eyebrow: PropTypes.string,
  headline: PropTypes.string,
  offers: PropTypes.arrayOf(PropTypes.instanceOf(Object)),
}

PromoGrid.defaultProps = {
  bodyCopy: '',
  eyebrow: '',
  headline: '',
  offers: [],
}

export default PromoGrid
